import alt from "../alt";

class AppActions {
  constructor() {
    this.generateActions(
      "fetchSettings",
      "fetchEventBuckets",
      "setKioskMode",
      "setPreviewMode",
      "setAdvanceSingleTicketsMode",
      "setKioskCode",
      "updateSettings",
      "fetchFailed",
      "unlock",
      "unlockFailed"
    );
  }
}

export default alt.createActions(AppActions);



// WEBPACK FOOTER //
// ./src/app/actions/AppActions.js